import React from 'react';

import {
  useCreateExceptionForm,
  useCreateException,
  useQueryAppConfig,
} from '@amzn/awsscmui-argo-inventory-exception/common/main';

import { ExceptionModal } from './ExceptionsModal';
import { DEFAULT_ERROR_MESSAGE } from './constants';
import { NotifyProps } from './types';

interface ArgoExceptionProps {
  setNotify: (notify: any) => void;
  formState: any;
  appConfig?: any;
  notify: NotifyProps;
  onDismiss: () => void;
}

export function ArgoException({ setNotify, notify, formState, onDismiss }: Omit<ArgoExceptionProps, 'appConfig'>) {
  const { onSubmit } = useCreateException();
  const appConfig = useQueryAppConfig(false);

  const handleOnArgoFormSubmit = async (values, helpers) => {
    return onSubmit({
      values,
      helpers,
      onCompleted: (response: unknown, error: Error | null) => {
        if (error) {
          setNotify({
            error: {
              message: DEFAULT_ERROR_MESSAGE,
              context: {
                // error,
              },
            },
          });
          return;
        }
        setNotify({
          success: {
            message: `Successfully created exception - ${response?.exceptionId}`,
            context: {
              exceptionId: response?.exceptionId,
              title: response?.title || 'Exception Id',
            },
          },
        });
      },
    });
  };

  const form = useCreateExceptionForm(handleOnArgoFormSubmit);

  return (
    <ExceptionModal
      form={form}
      notify={notify}
      formState={{ ...formState }}
      appConfig={appConfig}
      show
      onDismiss={onDismiss}
    />
  );
}
